export enum Misc
{
    codeview = 'codeview' ,
    undo = 'undo',
    redo = 'redo',
}
